import React from 'react';

export const LinkedInIcon = ({ className = '' }) => (
  <svg
    className={className}
    width="51"
    height="51"
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.8203 0.212402C12.0132 0.212402 0.820312 11.4053 0.820312 25.2124C0.820312 39.0195 12.0132 50.2124 25.8203 50.2124C39.6274 50.2124 50.8203 39.0195 50.8203 25.2124C50.8203 11.4053 39.6274 0.212402 25.8203 0.212402ZM17.95 19.5452C19.1672 19.5452 20.1539 18.5584 20.1539 17.3412C20.1539 16.1241 19.1672 15.1373 17.95 15.1373C16.7328 15.1373 15.7461 16.1241 15.7461 17.3412C15.7461 18.5584 16.7328 19.5452 17.95 19.5452ZM20.2522 21.4342H15.7461V35.2875H20.2522V21.4342ZM32.5145 21.593C32.5184 21.5942 32.5222 21.5955 32.5261 21.5967C34.4618 22.1017 35.8962 23.846 35.8962 25.9391V35.2875H31.3914V26.4718C29.9544 22.9883 26.5491 27.7312 26.5491 27.7312V35.2875H22.043V21.4342H26.5491V24.0827C27.0982 23.3447 28.7643 21.4342 31.3914 21.4342C31.6987 21.4342 31.9606 21.4682 32.1999 21.5161C32.2616 21.5262 32.3221 21.5375 32.3825 21.5514C32.4161 21.5606 32.4474 21.5709 32.4786 21.5813L32.4788 21.5813L32.4788 21.5813C32.4907 21.5852 32.5025 21.5891 32.5145 21.593Z"
      fill="#F1F2F3"
      fillOpacity="0.31"
    />
  </svg>
);
